import React from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { BASE_COLOR } from 'shared/constants/colors';
import {
  overlayOpenStartMenu,
  overlayClose,
} from 'shared/actions/view/web';
import { compose, decodeJwt } from 'shared/helpers';
import {
  GLOBAL_STYLE,
  OVERLAY_PORTAL_ROOT_ID,
  OVERLAY_TYPE_START_MENU,
  OVERLAY_TYPE_COMPOSE_EDITOR,
  // NAVBAR_DYNAMIC_DISPLAY_ATTR,
  NAVBAR_DEFINED_DISPLAY_ATTR,
  NAVBAR_PORTAL_ROOT_ID,
} from 'shared/constants/web';

import { mixClasses as cx } from 'helpers';
import {
  StartMenu,
  ComposeEditor,
} from 'components/overlays';
import { Portal } from 'components/elems';
// import { ErrorBoundary } from 'components/utils';
import { withSessionState } from 'components/hocs';
import {
  OverlayCloseControl,
  AuthActionControlGroup,
  CoreActionControlGroup,
} from './_navbar';

const { SHOW_CONTROL_GROUP } = NAVBAR_DEFINED_DISPLAY_ATTR;

// TODO: Maybe pull overlay and notifcation outside of Navbar?


// Define any navbar rendering atttributes, and
// which routes they should apply
const definedAttrsForRoutes = {
  [SHOW_CONTROL_GROUP]: [
    '/login',
    '/signup',
    '/welcome',
  ],
};

// Restructure definedAttrsForRoutes to group by each route
// for easier parsing below.
const definedAttrsByRoute = Object.keys(definedAttrsForRoutes)
  .reduce((acc, key) => {
    const targetRoutes = definedAttrsForRoutes[key];
    for (const route of targetRoutes) {
      acc[route] = (acc[route] || []).concat(key);
    }
    return acc;
  }, {});


// References: https://stackoverflow.com/q/34458261/3479934
function mapStateToProps(state) {
  return {
    navbarViewState: state.view.get('navbar'),
    overlayViewState: state.view.get('overlay'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    overlayOpenStartMenu,
    overlayClose
  }, dispatch);
}


/*
 * Navbar
 */
class Navbar extends React.Component {

  componentWillReceiveProps(nextProps) {
    // When overlay is active, disallow body to scroll when
    // scrolling in overlay.
    // Reference: http://jaketrent.com/post/update-body-class-react/
    const overlayIsActive = nextProps.overlayViewState.get('isActive');
    document.body.classList.toggle('overflow-hidden', overlayIsActive);
  }

  getLhsInner() {
    // XXX: Temporarily hide top left log until we make it dynamic..
    return null;

    // const overlayViewState = this.props.overlayViewState;
    // const overlayIsActive = overlayViewState.get('isActive');
    // const linkType = overlayIsActive ? 'disabled' : 'basic';
    //
    // return (
    //   <span className="moa-ff-argent">
    //     <Link type={linkType} to="/">Moagraph</Link>
    //   </span>
    // );
  }

  getRhsInner() {
    // If we have an active overlay, we need to first
    // figure out the right controls for the overlay.
    const overlayViewState = this.props.overlayViewState;
    // const overlayIsActive = overlayViewState.get('isActive');
    if (overlayViewState.get('isActive')) {
      const overlayDisplayContext = overlayViewState.get('displayContext');
      const Rhs = {
        [OVERLAY_TYPE_START_MENU]: OverlayCloseControl,
      }[overlayDisplayContext] || OverlayCloseControl;

      const overlayDisplayAttrs = overlayViewState.get('displayAttrs');
      return <Rhs overlayDisplayAttrs={overlayDisplayAttrs} />;
    }

    // If no overlay, then check if any additional rendering
    // behaviors have been specified for current route.
    const pathname = this.props.location.pathname;
    const definedAttrsForRoute = definedAttrsByRoute[pathname] || [];
    if (definedAttrsForRoute.includes(SHOW_CONTROL_GROUP)) {
      return null;
    }

    // Auth sensitive controls.
    const jwt = this.props.sessionState.get('jwt');
    const { sub: handle } = decodeJwt(jwt);
    return (handle
      ? <CoreActionControlGroup handle={handle} />
      : <AuthActionControlGroup />
    );
  }

  getOverlayInner() {
    const overlayViewState = this.props.overlayViewState;
    if ( !overlayViewState.get('isActive') ) {
      return null;
    }

    const overlayDisplayContext = overlayViewState.get('displayContext');
    const startMenuDisplayContext = this.props.overlayViewState.getIn(
      ['startMenu', 'displayContext']
    );

    const overlayInner = {
      [OVERLAY_TYPE_START_MENU]: (
        <StartMenu displayContext={startMenuDisplayContext} />
      ),
      [OVERLAY_TYPE_COMPOSE_EDITOR]: (
        <ComposeEditor />
      ),
    }[overlayDisplayContext];

    return overlayInner;
  }

  render() {
    const { classes: cn, navbarViewState } = this.props;

    const navbarIsVisible = navbarViewState.get('isVisible');
    if ( !navbarIsVisible ) {
      return null;
    }

    const lhsInner = this.getLhsInner();
    const rhsInner = this.getRhsInner();
    const overlayInner = this.getOverlayInner();

    const overlayPortalRoot = document.getElementById(OVERLAY_PORTAL_ROOT_ID);

    return (
      <div
        className={cx(
          cn.root,
          'flex items-center justify-center',
          '-outer-ph-rwd w-100',
        )}
      >
        <div className={cx(cn.widthCon, 'w-100 flex items-center justify-between')}>
          <div className="pv2 f3 z-2">{lhsInner}</div>
          {/* z-index lower than siblings */}
          <div
            id={NAVBAR_PORTAL_ROOT_ID}
            className="z-1"
          />
          <div className="z-2">{rhsInner}</div>
        </div>

        {/*
          TODO:
          Put back ErrorBoundary to wrap inside portal again?
          Provide fallback component with proper styling
        */}
        <Portal node={overlayPortalRoot}>
          <div className={cx(
            cn.overlayCon,
            {[cn.overlayShow]: overlayInner},
            'fixed absolute--fill overflow-y-scroll'
          )}>
            {overlayInner}
          </div>
        </Portal>

        <div className={cx(
          cn.bgTransparent,
          // cn.bgOpaque, // TODO: make this conditional
          // {[cn.bgTransparent]: overlayInner || hasTransparentBg},
          '-abs-fill'
        )} />
      </div>
    );
  }
}

const styles = {
  root: {
    height: GLOBAL_STYLE.navbarBodyHeight,
    // note(thx): To make vertically centered
    paddingBottom: GLOBAL_STYLE.navbarDebugHeight,
  },
  widthCon: {
    // XXX: Maybe some level higher up than navbar?
    // maxWidth: GLOBAL_STYLE.contentMaxWidth,
  },
  overlayCon: {
    transition: 'all 150ms cubic-bezier(.55,.055,.675,.19)',
    background: 'transparant',
    visibility: 'hidden',
    opacity: 0,
  },
  overlayShow: {
    background: BASE_COLOR.white,
    visibility: 'visible',
    opacity: 1,
  },
  bgOpaque: {
    opacity: 0.70,
    background: BASE_COLOR.white,
    transition: 'all 150ms',
  },
  bgTransparent: {
    opacity: 0,
    // transitionDelay: '200ms',  // XXX: Can't remember why it's here.
  },
};


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withSessionState(),
  injectSheet(styles),
)(Navbar);



// WEBPACK FOOTER //
// ./src/components/navs/Navbar.js